import { render } from "./MarketingDatatableTDMailingTitle.vue?vue&type=template&id=47f79e9e"
import script from "./MarketingDatatableTDMailingTitle.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDMailingTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__